import * as React from "react"
import { configOptions } from "./config"

export const SearchDropdownWidgetDescription = {
  name: 'SearchDropdown',
  component: React.lazy(() => import('./search-dropdown-widget' )),
  label: 'SearchDropdown',
  icon: 'lucide-text-cursor-input',
  variables: configOptions
}
